import * as React from "react";
import { PayLaterLinkState, GetPayLaterLinkAction } from "@payment-client/reducers/PayLater";

export type PaylaterLinkedContextValue = {
    setPaylaterState: React.Dispatch<GetPayLaterLinkAction>;
    paylaterState: PayLaterLinkState;
    refetchPaylaterLinkStatus: (walletName: string) => Promise<void>;
};

export const PaylaterLinkedContext = React.createContext<PaylaterLinkedContextValue>({
    paylaterState: {},
    setPaylaterState: () => void 0,
    refetchPaylaterLinkStatus: () => Promise.resolve(),
});

if (__DEV__) {
    PaylaterLinkedContext.displayName = "PaylaterLinkedContext";
}
